import CheckIcon from 'components/icons/Check';
import { FC } from 'react';
import styled from 'styled-components';
import { hasSpecialChar, isPwdLong } from 'utils/isPasswordValid';

const Text = styled.div`
  color: var(--gray-700);
  font-size: 0.9rem;
  margin-bottom: 0.7rem;
`;

const Li = styled.div`
  color: var(--gray-700);
  font-size: 0.9rem;
  stroke: transparent;
  margin-left: 1rem;
  position: relative;

  svg {
    position: absolute;
    height: 100%;
    left: -1rem;
  }

  &.active {
    color: var(--success-500);
    stroke: var(--success-500);
  }
`;

type Props = {
  password: string;
  marginTop?: number;
};
const PasswordRequirements: FC<Props> = ({ password, marginTop }) => {
  return (
    <div style={{ marginTop: marginTop ? `${marginTop}rem` : '' }}>
      <Text>Votre mot de passe doit:</Text>
      <Li className={isPwdLong(password) ? 'active' : ''}>
        <CheckIcon />
        Contenir au moins 8 caractères
      </Li>
      <Li className={hasSpecialChar(password) ? 'active' : ''}>
        <CheckIcon />
        Contenir au moins 1 caractère spécial
      </Li>
    </div>
  );
};

export default PasswordRequirements;
